<div class="slider-container">
  <div class="slider-header-row">
    <label *ngIf="data?.showLabel !== false && label" class="slider-label">{{ label }}<span class="dvm-mandatory-mark" *ngIf="isMandatory" aria-hidden="true">*</span></label>
    <button
      *ngIf="canCompute"
      type="button"
      class="slider-compute-trigger"
      title="On-the-Fly Computation"
      aria-label="On-the-Fly Computation"
      (click)="toggleCompute($event)"
    >
      <span class="material-icons">bolt</span>
    </button>
  </div>

  <div class="slider-inputs input-group">
    <!-- Single input box bound to the (single) slider handle value. -->
    <mat-form-field appearance="outline" class="slider-field">
      <input
        matInput
        type="number"
        [(ngModel)]="rangeEnd"
        [min]="min"
        [max]="max"
        [step]="step"
        (input)="validateAndEmit()"
      />
      <mat-error *ngIf="errorMsg">{{ errorMsg }}</mat-error>
    </mat-form-field>
    <span class="slider-formatted-value" *ngIf="formattedValue">≈ {{ formattedValue }}</span>
  </div>

  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
  >
    <!-- The change event lives on the thumb input (Angular Material), not on
         <mat-slider> — bind it here so dragging reliably re-emits on release. -->
    <input matSliderThumb [(ngModel)]="rangeEnd" (change)="onRangeChange()" />
  </mat-slider>

  <div class="slider-compute-popover" *ngIf="computeOpen" (click)="$event.stopPropagation()">
    <div class="compute-header">
      <strong>On-the-Fly Computation</strong>
      <button type="button" class="compute-close" aria-label="Close" (click)="closeCompute()">x</button>
    </div>

    <div class="compute-body">
      <div class="compute-chips" *ngIf="allColumns.length">
        <button
          *ngFor="let column of allColumns"
          type="button"
          class="compute-chip"
          [class.numeric]="column.type === 'number'"
          (click)="appendColumn(column)"
        >
          {{ column.name }}
        </button>
      </div>

      <label class="compute-label">Entity Name</label>
      <input class="compute-input" type="text" [value]="entityName" readonly placeholder="No entity found" />

      <label class="compute-label">Expression</label>
      <div class="compute-expression-row">
        <input class="compute-input" type="text" [(ngModel)]="currentExpression" placeholder="e.g. price + margin" />
        <input class="compute-input alias" type="text" [(ngModel)]="currentAlias" placeholder="Alias" />
        <button type="button" class="compute-add" (click)="addComputation()">+</button>
      </div>
      <small class="compute-error" *ngIf="expressionError">{{ expressionError }}</small>

      <div class="compute-list" *ngIf="computations.length">
        <div class="compute-item" *ngFor="let entry of computations; trackBy: trackByComputation">
          <span>{{ entry.raw }}</span>
          <button type="button" (click)="removeComputation(entry.id)">x</button>
        </div>
      </div>

      <div class="compute-section" *ngIf="numericColumns.length">
        <label class="compute-label">Range Filters</label>
        <div class="compute-chips">
          <button
            *ngFor="let column of numericColumns"
            type="button"
            class="compute-chip"
            [class.active]="hasFilter(column.name)"
            (click)="toggleFilter(column)"
          >
            {{ column.name }}
          </button>
        </div>
      </div>

      <div class="range-list" *ngIf="numericFilters.length">
        <div class="range-item" *ngFor="let filter of numericFilters; trackBy: trackByFilter">
          <div class="range-title">
            <span>{{ filter.column }}</span>
            <button type="button" (click)="removeFilter(filter.column)">x</button>
          </div>
          <div class="range-inputs">
            <input type="number" [min]="filter.absoluteMin" [max]="filter.currentMax" [value]="filter.currentMin" (change)="updateFilterValue(filter, 'currentMin', $event)" />
            <input type="number" [min]="filter.currentMin" [max]="filter.absoluteMax" [value]="filter.currentMax" (change)="updateFilterValue(filter, 'currentMax', $event)" />
          </div>
        </div>
      </div>

      <pre class="compute-preview" *ngIf="computationResultPreview">{{ computationResultPreview | json }}</pre>
      <small class="compute-error" *ngIf="computationErrorMessage">{{ computationErrorMessage }}</small>
      <small class="compute-success" *ngIf="computationSuccessMessage">{{ computationSuccessMessage }}</small>
    </div>

    <div class="compute-footer">
      <button type="button" class="compute-secondary" (click)="clearComputations()">Clear All</button>
      <button type="button" class="compute-primary" [disabled]="computationLoading" (click)="applyComputations()">
        {{ computationLoading ? 'Applying...' : 'Apply' }}
      </button>
    </div>
  </div>
</div>
